export const isEmpty = function (val) {
  return val === undefined || val === 'undefined' || val === '' || val === null || val === 'null'
}

// 判断数组是否为空
export const isEmptyArray = function (array) {
  return array === undefined || array === 'undefined' || array === '' || array === null || array === 'null' || array.length <= 0
}

export const stringHidden = function (str, frontLen, endLen) {
  // str：要进行隐藏的变量  frontLen: 前面需要保留几位    endLen: 后面需要保留几位
  const len = str.length - frontLen - endLen
  let xing = ""
  for (let i = 0; i < len; i++) {
    xing += "＊"
  }
  return (
    str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
  )
}
/**
 * 校验数字
 * @param {} val
 * @returns
 */
export const isNumber = function (val) {
  const regPos = /^\d+(\.\d+)?$/ // 非负浮点数
  const regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/  // 负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
      return true
  } else {
      return false
  }
}

export const ResetObject = function (obj) {
  if (!isEmpty(obj)) {
    Object.keys(obj).forEach(key => {
      if (typeof obj[key] === 'object') {
          ResetObject(obj[key])
      } else {
        obj[key] = null
      }
    })
  }
}

export const ResetArray = function (obj) {
  if (!isEmpty(obj)) {
    Object.keys(obj).forEach(key => {
      if (obj instanceof Array) {
        obj.forEach((item) => {
          ResetObject(item)
        })
      } else {
        obj[key] = []
      }
    })
  }
}

/**
 * @param {Object} target
 * @param {Object} source
 * 简单复制对象属性，只限相同属性，相当于赋值
 */
export const simpleCopeObjectIdentical = function (target, source) {
	for (const targetKey in target) {
    for (const sourceKey in source) {
        if (targetKey === sourceKey) {
        target[targetKey] = source[sourceKey]
      }
    }
	}
	return target
}
/**
 * @param {Object} str
 * 字符串首字母转大写
 */
export const firstToUpper = function (str) {
    return str.trim().toLowerCase().replace(str[0], str[0].toUpperCase());
}
/**
 * @param {Object} name
 * 下划线转换驼峰
 */
export const toHump = function (name) {
    return name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase())
}
/**
 * @param {Object} name
 * 驼峰转换下划线
 */
export const toLine = function (name) {
  return name.replace(/([A-Z])/g, "_$1").toLowerCase()
}
/**
 * 超出隐藏
 * @param {Object} str 原始字符
 * @param {Object} len 超出长度
 */
export const cutString = function (str, len) {
  if (str.length * 2 <= len) {
    return str
  }
  let strlen = 0
  let s = ''
  for (let i = 0; i < str.length; i++) {
    s += str.charAt(i)
    if (str.charCodeAt(i) > 128) {
      strlen += 2
      if (strlen >= len) {
        return `${s.substring(0, s.length - 1)}...`
      }
    } else {
      strlen += 1
      if (strlen >= len) {
        return `${s.substring(0, s.length - 2)}...`
      }
    }
  }
  return s
}
export const serialNumber = function(prefix = 'YD.', suffix = '') {
    const now = new Date()
    const year = now.getFullYear().toString()
    const month = now.getMonth() + 1
    const day = now.getDate()
    const hour = now.getHours()
    const minutes = now.getMinutes()
    const seconds = now.getSeconds()
    // const milli = now.getMilliseconds()
    return prefix + year + month + day + hour + minutes + seconds + suffix
}

export const fmAuditColor = function(status) {
  return status === 0 ? 'warning' : status === 1 ? 'green' : status === -1 ? 'error' : ''
}

export const fmOrderColor = function(status) {
  return status === 179 ? 'warning' : status === 178 ? 'green' : status === 180 ? 'error' : ''
}